import script from "./kejianadd.vue?vue&type=script&setup=true&lang=js"
export * from "./kejianadd.vue?vue&type=script&setup=true&lang=js"

import "./kejianadd.vue?vue&type=style&index=0&id=7fc6688f&lang=less&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7fc6688f"]])

export default __exports__